<div cdkOverlayOrigin
     #origin="cdkOverlayOrigin"
     #originEle
     (keyup.escape)="showResult = false"
     (keydown.tab)="onInputTab($event)"
     (keydown.arrowDown)="onInputArrowDown()">
    <div class="ac">
        <div class="form-group-inline" [ngClass]="showResult ? 'ac__inputWrapper': ''">
            <div class="ac__input-with-reset">
                <input #searchInput
                       [placeholder]="placeholder"
                       [disabled]="disabled"
                       [ngClass]="class"
                       class="inputField"
                       [(ngModel)]="search">
                <a class="ac__reset-icon icon-shut" href="javascript:void(0)"
                   *ngIf="!disabled && search?.length > 0"
                   (keydown.space)="onResetIconClick($event)"
                   (click)="onResetIconClick($event)"></a>
            </div>
            <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
        </div>
        <ng-content></ng-content>
    </div>
</div>

<ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayOpen]="showResult"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    (backdropClick)="showResult = false"
    (detach)="onDetach()">

    <div class="common-forms-select" *ngIf="!disabled && selectableItems && selectableItems.length">
        <ul commonKeyboardList
            commonKeyboardListNavArrow
            commonKeyboardListNavTab
            #keyboardList=commonKeyboardList
            (commonKeyboardListThresholdTop)="onKeyboardBlur()"
            class="items-container scrollbar ac__items" [ngClass]="class">
            <ng-template [ngIf]="showResult">
                <li *ngFor="let item of selectableItems"
                    class="select-items"
                    commonKeyboardItem
                    (keydown.enter)="onSelect($event, item)"
                    (keydown.space)="onSelect($event, item)"
                    (click)="onSelect($event, item)">
                    <span>{{item[displayValue]}}</span>
                </li>
            </ng-template>
            <ng-template [ngIf]="notFound">
                <li class="select-items">
                    <span>{{notFound}}</span>
                </li>
            </ng-template>
        </ul>
    </div>
</ng-template>
